import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import theme from "theme";

const Content = styled.div`
  background: ${({ theme }) => theme.white};
  border-radius: 5px;
  /* border: solid 1px ${({ theme }) => theme.dark}; */
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
  padding: 8px;
  position: absolute;
  bottom: calc(100% + 12px);

  ${({ offset }) =>
    offset && `transform: translate(${offset.x || 0}, ${offset.y || 0});`}

  ${({ visible }) => !visible && `display: none`};
`;

// 倒三角
const Triangle = styled.div`
  position: absolute;
  /* 宽高为0 使边框直接围成了正方形 */
  height: 0;
  width: 0;
  border-style: solid;
  border-width: 6px 6px 0 6px;
  /* 上边框有颜色 */
  border-color: ${({ theme }) => theme.white} transparent transparent
    transparent;
  left: calc(50% - 6px);
  bottom: calc(100% + 12px - 5px);

  ${({ offset }) => offset && `transform: translateY(${offset.y || 0});`}

  ${({ visible }) => !visible && `display: none`};
`;

const Target = styled.div``;

const StyledPopover = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`;

function Popover({
  children,
  content,
  onVisible,
  onHide,
  offset = {},
  ...rest
}) {
  // 是否显示
  const [visible, setVisible] = useState(false);

  const handleClick = useCallback(() => {
    visible ? onHide && onHide() : onVisible && onVisible();
    setVisible(!visible);
  }, [visible, onVisible, onHide]);

  return (
    <StyledPopover {...rest} onClick={handleClick}>
      <Content offset={offset} visible={visible}>
        {content}
      </Content>
      <Triangle offset={offset} visible={visible} />
      <Target>{children}</Target>
    </StyledPopover>
  );
}

Popover.propTypes = {
  children: PropTypes.any,
  content: PropTypes.any,
  offset: PropTypes.shape({ x: PropTypes.string, y: PropTypes.string }),
  onVisible: PropTypes.func,
  obHide: PropTypes.func,
};

export default Popover;
